import { CellProps } from 'react-table'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import { AtendimentoMedicoActionsCell } from './AtendimentoMedicoActionsCell'
import {
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusDot,
  TableColumn,
} from '../../../../../../components'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { RiscoTriagemCell } from './RiscoTriagemCell'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const atendimentosMedicosColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<AtendimentoList>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Sem ordenação por clique: a ordem por risco é fixa (fixedSort) e um clique aqui
  // tiraria a cor do primeiro critério.
  {
    Header: () => <PlainHeader>{t('triagem.risco')}</PlainHeader>,
    id: 'triagem',
    cellWidth: '140px',
    Cell: ({ row }: CellProps<AtendimentoList>) => <RiscoTriagemCell atendimento={row.original} />,
  },
  // Paciente com o protocolo como apoio; os dois seguem ordenáveis.
  sortableColumn<AtendimentoList>({
    id: 'paciente.pessoa.nome',
    useQueryRequest,
    fields: [
      { field: 'paciente.pessoa.nome', label: t('cols.paciente') },
      { field: 'protocolo', label: t('cols.protocolo') },
    ],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell
        tabular
        primary={row.original.paciente?.pessoa?.nome}
        secondary={row.original.protocolo}
      />
    ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'especialidade.nome',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'especialidade.nome', label: t('cols.especialidade') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell primary={row.original.especialidade?.nome} />
    ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'solicitacao',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'solicitacao', label: t('cols.agendamento') }],
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <StackedCell
        tabular
        primary={formatDateTime(row.original.solicitacao, row.original.solicitacaoFormatada)}
      />
    ),
  }),
  // Presença e online em texto + tom (antes só um ponto colorido: cor não pode ser o único sinal).
  sortableColumn<AtendimentoList>({
    id: 'presencaPaciente',
    cellWidth: '140px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'presencaPaciente', label: 'Presença' }],
    Cell: ({ row }: CellProps<AtendimentoList>) =>
      row.original.presencaPacienteFormatada ? (
        <StatusDot label='Presente' tone='success' />
      ) : (
        <StatusDot label='Ausente' tone='danger' />
      ),
  }),
  sortableColumn<AtendimentoList>({
    id: 'pacienteOnline',
    cellWidth: '120px',
    useQueryRequest,
    fields: [{ field: 'pacienteOnline', label: 'Online' }],
    Cell: ({ row }: CellProps<AtendimentoList>) =>
      row.original.pacienteOnline ? (
        <StatusDot label='Online' tone='success' />
      ) : (
        <StatusDot label='Offline' tone='danger' />
      ),
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '104px',
    align: 'end',
    Cell: ({ row }: CellProps<AtendimentoList>) => (
      <AtendimentoMedicoActionsCell atendimento={row.original} />
    ),
  },
]
